var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-location"},_vm._l((_vm.menuList),function(txt,index){return _c('span',{key:index},[_vm._v(_vm._s(txt))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }